import { render } from "./BadgeValueSetting.vue?vue&type=template&id=28c791fe"
import script from "./BadgeValueSetting.vue?vue&type=script&lang=js"
export * from "./BadgeValueSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__